
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyNight as ObiPartlycloudyNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-night.js';
 
 
 

 
 export const ObiPartlycloudyNight = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-night',
   elementClass: ObiPartlycloudyNightElement,
   events: {
     
   }
  });
 
 